import React, { useEffect, useState } from "react";
import SEO from "components/seo";
import styled from "@emotion/styled";
import QRCode from "qrcode.react";
import { ToastContainer } from "react-toastify";
import Button from "../components/Button";
import { ThemeProvider } from "emotion-theming";
import { inverted } from "utils/themes";
import { Link, navigate } from "gatsby";
import { toastActions } from "modules/toast";
import playgrounds from "api/zeus/playgrounds";

import "react-toastify/dist/ReactToastify.css";

async function getSignedId() {
  return (await playgrounds.getMySignedId()).data.signed_id;
}

const WelcomeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
`;

const Title = styled.h3`
  font-family: ${props => props.theme.fonts.subheading};
  font-weight: bold;
  text-align: center;
`;

const QRContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

const QRMargin = styled.div`
  height: 280px;
  width: 280px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
`;

const WidthButton = styled(Button)`
  width: 160px;
`;

export default function Onboarding() {
  const [signedId, setSignedId] = useState();

  useEffect(async () => {
    setSignedId(await getSignedId());
  }, []);

  if (!signedId) {
    return null;
  }

  async function handleClick() {
    try {
      await playgrounds.getMyProfile();
      navigate("/how-to-play");
    } catch (e) {
      toastActions.showToast("Belom kepair");
    }
  }

  return (
    <ThemeProvider theme={inverted}>
      <WelcomeContainer>
        <SEO title="Welcome to Playground" />
        <Title>WELCOME!</Title>
        <p css={{ textAlign: "center" }}>
          Hello newbie, welcome to our playground. Before you get into our
          world, please go to the venue entrance and ask the organizer to scan
          your code and get your bracelet.
        </p>
        <QRContainer>
          <QRMargin>
            <QRCode value={signedId} size={250} level="H" />
          </QRMargin>
        </QRContainer>
        <WidthButton onClick={handleClick}>Next</WidthButton>
        <ToastContainer
          toastClassName="toast-container"
          bodyClassName="toast-body"
          position="bottom-center"
          hideProgressBar={true}
          autoClose={2000}
        />
      </WelcomeContainer>
    </ThemeProvider>
  );
}
